<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters class="pt-8 px-16 mx-16">
        <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <td >
                  <span class="text-subtitle-2 font-weight-bold">{{$t('Upload date')}}</span>
                </td>
                <td >
                  <span class="text-subtitle-2 font-weight-bold">{{$t('Donate for')}}</span>
                </td>
                <td>
                  <span class="text-subtitle-2 font-weight-bold">{{$t('Name of salvation')}}</span>
                </td>
                <td >
                  <span class="text-subtitle-2 font-weight-bold">{{$t('Name of the person ordering')}} </span>
                </td>
                <td >
                  <span class="text-subtitle-2 font-weight-bold">{{$t('Phone')}} </span>
                </td>
                <td class="text-center">
                  <span class="text-subtitle-2 font-weight-bold"> {{$t('Package')}} </span>
                </td>
                <td >
                  <span class="text-subtitle-2 font-weight-bold"> {{$t('Paid')}} </span>
                </td>
                <td >
                  <span class="text-subtitle-2 font-weight-bold">{{$t('Ad status')}}</span>
                </td>
                <td >
                  <span class="text-subtitle-2 font-weight-bold">{{$t('Edited')}}</span>
                </td>
                <td >
                  <span class="text-subtitle-2 font-weight-bold">{{$t('Eraser')}}</span>
                </td>
                <td v-if="tab === 'pending'">
                  <span class="text-subtitle-2 font-weight-bold">{{$t('Publish')}}</span>
                </td>
              </tr>
              </thead>
              <tbody>
              <tr :key="item.id" v-for="item in donates">
                <td>
                  <span>{{ moment(item.created_at).format("DD/MM/YYYY HH:mm") }}</span>
                </td>
                <td>
                  <span>{{ getDedication(item.dedication) }}</span>
                </td>
                <td>
                  <span>{{ item.name }}</span><br>
                  <span>{{ item.mother_name }}</span>
                </td>
                <td>
                  <span>{{ item.order_name }}</span>
                </td>
                <td>
                  <span>{{ item.order_phone }}</span>
                </td>
                <td>
                  <span>{{ item.package_period * item.quantity }} שעות</span>
                </td>
                <td>
                  <span>{{ item.package_price * item.quantity }} ₪</span>
                </td>
                <td>
                  <v-chip
                      v-if="getStatus(item.status)"
                      :color="getStatus(item.status).color"
                      :text-color="getStatus(item.status).accentColor"
                  >
                    <v-icon>mdi-circle-small</v-icon>
                    {{ getStatus(item.status).text }}
                  </v-chip>
                </td>
                <td>
                  <v-btn text width="32" height="32" class="square-btn" @click="onGotoBanner(item)">
                    <v-icon left class="mx-0">
                      mdi-pencil-outline
                    </v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn text width="32" height="32" class="square-btn" @click="onShowAlert(item, 'delete')">
                    <v-icon left class="mx-0">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-btn>
                </td>
                <td v-if="tab === 'pending'">
                  <v-btn depressed block outlined @click="onShowAlert(item, 'approve')">
                    {{ $t("Which") }}
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-8 px-16 mx-16 justify-space-between">
        <v-col cols="auto">
          <v-row class="align-center">
            <v-col><span class="text-subtitle-2">{{ $t('Show') }}</span></v-col>
            <v-col cols="auto">
              <v-select
                :items="limitOptions"
                v-model="limit"
                outlined
                dense
                hide-details
                single-line
                class="limit-select"
              ></v-select>
            </v-col>
            <v-col><span class="text-subtitle-2">{{ $t('Rows') }}</span></v-col>
          </v-row>
        </v-col>
        <v-col cols="auto">
          <v-pagination
              color="#727272"
              v-model="page"
              total-visible="6"
              :length="Math.ceil(total / limit)"
              @input="getData"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog v-model="showDialog" max-width="290">
      <v-card>
        <v-card-title class="text-h5"> {{ action === 'delete' ? $t('delete') : $t('Publish') }} </v-card-title>
        <v-card-text> {{ $t('are you sure') }}? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="showDialog = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn v-if="action === 'delete'" color="green darken-1" text @click="disableItem(tempItem.id)">
            {{ $t('ok') }}
          </v-btn>
          <v-btn v-else-if="action === 'approve'" color="green darken-1" text @click="approveItem(tempItem.id)">
            {{ $t('ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from "@/api/api";

export default {
  props: {
    tab: String,
  },
  data() {
    return {
      donates: [],
      sortOptions: [],
      limitOptions: [10, 20, 30, 40],
      total: 0,
      limit: 10,
      page: 1,
      statusElements: [
        {
          value: 'pending',
          text: this.$t('pending'),
          color: '#FEEDED',
          accentColor: '#E45858',
        },
        {
          value: 'approved',
          text: this.$t('approved'),
          color: '#EDF5FE',
          accentColor: '#3083FF',
        },
        {
          value: 'published',
          text: this.$t('published'),
          color: '#F0FEED',
          accentColor: '#259800',
        },
        {
          value: 'expired',
          text: this.$t('expired'),
          color: '#E6E6E6',
          accentColor: '#727272',
        }
      ],
      dedicationOptions: [
        {
          value: 'upliftment_soul',
          label: this.$t('Upliftment of the soul')
        },
        {
          value: 'healing',
          label: this.$t('Healing')
        },
        {
          value: 'success',
          label: this.$t('Success')
        },
        {
          value: 'decent_pairing',
          label: this.$t('Decent pairing')
        },
        {
          value: 'salvation',
          label: this.$t('Salvation')
        },
        {
          value: 'repent',
          label: this.$t('Repent')
        }
      ],
      showDialog: false,
      tempItem: null,
      action: '',
    }
  },
  methods: {
    getDedication(value) {
      const found = this.dedicationOptions.find(d => d.value === value)
      return found ? found.label : value
    },
    getStatus(status) {
      return this.statusElements.find(s => s.value === status) || null
    },
    initLoad() {
      this.getData();
    },
    getData() {
      let status = ['pending'];
      if (this.tab === "approved") {
        status = ['approved', 'published', 'expired'];
      }
      this.$store.dispatch("SET_TOOLBARLOAD", true);
      const params = {
        limit: this.limit,
        offset: (this.page - 1) * this.limit,
        status: status,
      }
      api
        .getDonates(params)
        .then((res) => {
          this.$store.dispatch("SET_TOOLBARLOAD", false);
          if (res.data && res.data.donates.length > 0) {
            this.donates = res.data.donates;
            this.total = res.data.total;
          } else {
            this.donates = [];
          }
        })
        .catch((error) => {
          this.$store.dispatch("SET_TOOLBARLOAD", false);
          console.log(error);
        });
    },
    approveItem(id) {
      this.showDialog = false;
      this.$store.dispatch("SET_TOOLBARLOAD", true);
      api
        .approveDonate(id)
        .then((res) => {
          this.$store.dispatch("SET_TOOLBARLOAD", false);
          if (res.data && res.data.success === true) {
            this.$emit('approved', res.data.donate);
          }
        })
        .catch((error) => {
          this.$store.dispatch("SET_TOOLBARLOAD", false);
          console.log(error);
        });
    },
    disableItem(id) {
      this.showDialog = false;
      this.$store.dispatch("SET_TOOLBARLOAD", true);
      api
        .disableDonate(id)
        .then((res) => {
          this.$store.dispatch("SET_TOOLBARLOAD", false);
          if (res.data && res.data.success === true) {
            this.initLoad();
          }
        })
        .catch((error) => {
          this.$store.dispatch("SET_TOOLBARLOAD", false);
          console.log(error);
        });
    },
    onShowAlert(evt, action) {
      this.action = action;
      this.tempItem = evt;
      this.showDialog = true
    },
    onGotoBanner(item) {
      this.$router.push({ path: `/donates/${item.id}/banner` });
    }
  },
  watch: {},
  mounted() {
    this.initLoad();
  },
}
</script>

<style scoped>
.square-btn {
  padding: 0 !important;
  min-width: auto !important;
  border-color: #E7EAE9 !important;
}
::v-deep .square-btn:hover .v-icon {
  color: #ED220D;
}
::v-deep .v-badge--dot .v-badge__badge{
  height: 4px;
  width: 4px;
}
::v-deep thead {
  background-color: #F2F2F2;
}
::v-deep .v-chip.v-size--default {
  width: 110px;
}
::v-deep .v-chip .v-chip__content {
  width: 100%;
}
::v-deep .v-input.limit-select {
  width: 80px;
}
</style>
